import { render, staticRenderFns } from "./PersonalDesarrolloProfesional.vue?vue&type=template&id=22c8bc6f&scoped=true"
import script from "./PersonalDesarrolloProfesional.vue?vue&type=script&lang=js"
export * from "./PersonalDesarrolloProfesional.vue?vue&type=script&lang=js"
import style0 from "./PersonalDesarrolloProfesional.vue?vue&type=style&index=0&id=22c8bc6f&prod&scoped=true&lang=css"
import style1 from "./PersonalDesarrolloProfesional.vue?vue&type=style&index=1&id=22c8bc6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8bc6f",
  null
  
)

export default component.exports